import axios from "../../../config/axiosConfig";

export const listLeads = () => axios.get("/api/telusgy/leads");

export const updateLeadStatus = (id, status) =>
  axios.patch(`/api/telusgy/leads/${id}/status`, { status });

export const deleteLead = (id) => axios.delete(`/api/telusgy/leads/${id}`);
